import { Observable } from 'rxjs';

import { CdmDeviceUiDevice } from './models/cdm-device-ui-device';

export interface DeviceDiscoveryEvent {
	type: 'deviceAdded' | 'deviceRemoved';
	id: string;
}

export abstract class CdmDeviceUiApiService {
	public abstract getDevice$(deviceId: string): Observable<CdmDeviceUiDevice>;
	public abstract subscribeDiscoveredDevices$(): Observable<DeviceDiscoveryEvent>;
}
